module.exports = __webpack_public_path__ + "img/icon_trade_contract_trade_contract_response.e80fd422.svg";